import React, { useEffect } from "react";
import Icon from "../common/Icon";
import "./LeaderDetailModal.css";

const LeaderDetailModal = ({
  isOpen,
  onClose,
  title,
  data,
  metricLabel,
}) => {

  // Handle Escape key press
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // Disable body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="leader-modal-overlay" onClick={handleBackdropClick}>
      <div className="leader-modal-content">
        <div className="leader-modal-header">
          <h2 className="leader-modal-title">{title}</h2>
          <button
            className="leader-modal-close-button"
            onClick={onClose}
            aria-label="Fermer"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="leader-modal-body">
          {data && data.length > 0 ? (
            <>
              <div className="modal-table-container">
                <table className="modal-table">
                  <thead>
                    <tr>
                      <th>Rang</th>
                      <th>Domaine</th>
                      <th>{metricLabel}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item) => (
                      <tr key={item.rank}>
                        <td className="rank-cell">#{item.rank}</td>
                        <td className="domain-cell">{item.domain}</td>
                        <td className="value-cell">{item.formattedValue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <p className="modal-empty">Aucune donnée disponible</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderDetailModal;
